/**
 * Created by 胜 on 2017/6/11.
 */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {renderMoney} from '../../utils';

class LecturePayMonthPanel extends Component {
    constructor() {
        super();
        this.onSelectPay = this.onSelectPay.bind(this);
    }

    onSelectPay(e) {
        let selectMonthId = e.currentTarget.dataset.id;
        this.props.dispatch({
            type: 'LECTURE_SET_SELECT_PAY',
            payload: parseInt(selectMonthId, 10)
        });
    }

    render() {
        const {priceList} = this.props;
        return (
            <div>
                {priceList.map((item, index) => (
                    <div className="weui-actionsheet__cell weui-padding wk-border-line-bottom" data-id={item.id}
                         key={item.id}
                         onClick={this.onSelectPay}>
                        <p className="weui-flex">
                            <span className="weui-flex__item text-left flex_4">
                                <i className={"iconfont icon-zhengque " + (item.selected ? 'select' : 'no-select')}/>
                                <span className="padding-left">选择套餐{index + 1}: {item.month}个月 </span>
                            </span>
                                <span className="weui-flex__item text-right flex_2">
                                <span className="key-num fr">¥{renderMoney(item.money)}</span>
                            </span>
                        </p>
                    </div>
                ))}
            </div>
        )
    }
}

export default connect((state => ({
    priceList: state.lecture.channel.price_list
})))(LecturePayMonthPanel)


// WEBPACK FOOTER //
// ./src/components/lecture/LecturePayMonthPanel.js